export default function (ctrl) {
	return function () {
		ctrl.smsForm.smsCode.$setValidity('wrongSmsCode', true);
		ctrl.smsForm.smsCode.$setValidity('emailAlreadyExists', true);
	};
};
